/**
 * Style props for form field label
 * @property {("primary" | "secondary" | "dark-grey" | "black")} [textColor] - Text color
 * @property {("2xs" | "xs" | "sm" | "md" | "base")} [fontSize] - Font size
 * @property {("none" | "sm" | "md" | "lg")} [marginBottom] - Bottom margin
 * @property {("normal" | "medium" | "semibold" | "bold")} [fontWeight] - Font weight
 * @property {string} [className] - Additional Tailwind classes
 */
export interface InputLabelStyleProps {
  textColor?: "primary" | "secondary" | "dark-grey" | "black";
  fontSize?: "2xs" | "xs" | "sm" | "md" | "base";
  marginBottom?: "none" | "sm" | "md" | "lg";
  fontWeight?: "normal" | "medium" | "semibold" | "bold";
  className?: string;
}

export const defaultInputLabelStyles: InputLabelStyleProps = {
  textColor: "black",
  fontSize: "md",
  marginBottom: "lg",
  fontWeight: "normal",
};

export const inputLabelStylesMap = {
  fontSize: {
    "2xs": "text-2xs",
    xs: "text-xs",
    sm: "text-sm",
    md: "text-md",
    base: "text-base",
  },
  marginBottom: {
    none: "mb-0",
    sm: "mb-1",
    md: "mb-2",
    lg: "mb-3",
  },
  fontWeight: {
    normal: "font-normal",
    medium: "font-medium",
    semibold: "font-semibold",
    bold: "font-bold",
  },
} as const;
